import { HttpErrorResponse } from '@angular/common/http';
import { ApiError } from '../services/api-error-handler.service';

export class TypeGuard {
    public static isHttpApiError(error: unknown): error is HttpErrorResponse & { error: { error: ApiError } } {
        return (
            this.isHttpError(error) &&
            error.error != null &&
            typeof error.error === 'object' &&
            this.isApiError(error.error.error)
        );
    }

    public static isApiError(error: unknown): error is ApiError {
        if (
            error != null &&
            typeof error === 'object' &&
            'code' in error &&
            'message' in error &&
            typeof error.code === 'string' &&
            typeof error.message === 'string'
        ) {
            return true;
        }
        return false;
    }

    public static isHttpError(error: unknown): error is HttpErrorResponse {
        return error instanceof HttpErrorResponse;
    }
}
